<template>
    <div>
        <nav class="navbar-light text-left text-smallest font-weight-bold shadow side-nav mr-2"
             style="width: 115px;">
            <ul class="nav flex-column h-100p text-left">
                <li class="nav-item">
                    <router-link
                            :to="{name: 'CrewInternationalDocument'}"
                            tag="a"
                            class="nav-link text-dark"
                            :class="{'active': isActiveRoute('CrewInternationalDocument')}"
                            role="tab"
                            data-toggle="list"
                    >
                        International Documents
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link
                            :to="{name: 'CrewCertificate'}"
                            tag="a"
                            class="nav-link text-dark"
                            :class="{'active': isActiveRoute('CrewCertificate')}"
                            role="tab"
                            data-toggle="list"
                    >
                        Certificates
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link
                            :to="{name: 'CrewTraining'}"
                            tag="a"
                            class="nav-link text-dark"
                            :class="{'active': isActiveRoute('CrewTraining')}"
                            role="tab"
                            data-toggle="list"
                    >
                        Other Trainings
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link
                            :to="{name: 'CrewLicense'}"
                            tag="a"
                            class="nav-link text-dark"
                            :class="{'active': isActiveRoute('CrewLicense')}"
                            role="tab"
                            data-toggle="list"
                    >
                        Licenses
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link
                            :to="{name: 'FlagRequirement'}"
                            tag="a"
                            class="nav-link text-dark"
                            :class="{'active': isActiveRoute('FlagRequirement')}"
                            role="tab"
                            data-toggle="list"
                    >
                        Flag Requirements
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link
                            :to="{name: 'CrewMedical'}"
                            tag="a"
                            class="nav-link text-dark"
                            :class="{'active': isActiveRoute('Medical')}"
                            role="tab"
                            data-toggle="list"
                    >
                        Medical Documents
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link
                            :to="{name: 'CrewReport'}"
                            tag="a"
                            class="nav-link text-dark"
                            :class="{'active': isActiveRoute('CrewReport')}"
                            role="tab"
                            data-toggle="list"
                    >
                        Assessment Report
                    </router-link>
                </li>
<!--                <li class="nav-item">-->
<!--                    <router-link-->
<!--                            :to="{name: 'CrewCer'}"-->
<!--                            tag="a"-->
<!--                            class="nav-link text-dark"-->
<!--                            :class="{'active': isActiveRoute('CrewCer')}"-->
<!--                            role="tab"-->
<!--                            data-toggle="list"-->
<!--                    >-->
<!--                        CER-->
<!--                    </router-link>-->
<!--                </li>-->
            </ul>
        </nav>
        <router-view></router-view>
    </div>
</template>

<script>

    import { vueAppMixin } from "@/mixins/vueAppMixin";

    export default {
        name: "CrewDocument",
        mixins: [ vueAppMixin ],


    }
</script>

<style scoped>
    .nav-link.active, .nav-link:hover {
        background-color: #e87c87;
        color: white !important;
    }
</style>
